/**
 * The "API keys & webhook" tab: the account's keys (create — the plain key is
 * shown once —, revoke) and its webhook (URL, signing secret, test event).
 * Texts come from the documentation content, so the tab follows its language.
 */
define('apiDocsKeysView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'jquery',
  'apiDocsContent',
  'entities/api_keys'
], function (Module, App, Marionette, _, $, Content) {
  'use strict';

  function errorMessage(xhr, fallback) {
    var body = xhr && xhr.responseJSON;
    return (body && body.error && body.error.message) || fallback;
  }

  Module.exports = Marionette.ItemView.extend({
    className: 'api-docs-keys-view',

    template: _.template(
      '<section class="api-keys-card">' +
      '  <h2><i class="fa fa-key"></i> <%- t.keys.title %></h2>' +
      '  <p class="api-keys-intro"><%- t.keys.intro %></p>' +
      '  <form class="api-keys-create js-create-form">' +
      '    <input type="text" class="form-control js-name" maxlength="100"' +
      '      placeholder="<%- t.keys.namePlaceholder %>" aria-label="<%- t.keys.name %>">' +
      '    <button type="submit" class="btn btn-primary js-create"><i class="fa fa-plus"></i> <%- t.keys.create %></button>' +
      '  </form>' +
      '  <% if (created) { %>' +
      '  <div class="api-keys-created">' +
      '    <div class="api-keys-created-title"><i class="fa fa-check-circle"></i> <%- t.keys.createdTitle %> - <%- created.name %></div>' +
      '    <div class="api-keys-secret"><code class="js-created-key"><%- created.key %></code>' +
      '      <button type="button" class="api-doc-copy js-copy-key"><%- ui.copy %></button></div>' +
      '    <p><i class="fa fa-exclamation-triangle"></i> <%- t.keys.createdHint %></p>' +
      '  </div>' +
      '  <% } %>' +
      '  <% if (error) { %><div class="api-keys-error"><%- error %></div><% } %>' +
      '  <% if (!keys.length) { %>' +
      '  <div class="api-keys-empty"><%- t.keys.empty %></div>' +
      '  <% } else { %>' +
      '  <table class="api-doc-table api-keys-table">' +
      '    <thead><tr><th><%- t.keys.name %></th><th><%- t.keys.prefix %></th><th><%- t.keys.createdBy %></th>' +
      '      <th><%- t.keys.createdAt %></th><th><%- t.keys.lastUsed %></th><th><%- t.keys.status %></th><th></th></tr></thead>' +
      '    <tbody>' +
      '      <% _.each(keys, function (k) { %>' +
      '      <tr class="<%= k.active ? "" : "revoked" %>">' +
      '        <td><b><%- k.name %></b></td>' +
      '        <td><code><%- k.prefix %>...</code></td>' +
      '        <td><%- k.createdBy || "" %></td>' +
      '        <td><%- date(k.createdAt) %></td>' +
      '        <td><%- k.lastUsedAt ? date(k.lastUsedAt) : t.keys.never %></td>' +
      '        <td><span class="api-keys-status <%= k.active ? "on" : "off" %>">' +
      '          <%- k.active ? t.keys.active : t.keys.revoked %></span></td>' +
      '        <td><% if (k.active) { %><button type="button" class="btn btn-default btn-sm js-revoke"' +
      '          data-sec-id="<%- k.secId %>"><%- t.keys.revoke %></button><% } %></td>' +
      '      </tr>' +
      '      <% }); %>' +
      '    </tbody>' +
      '  </table>' +
      '  <% } %>' +
      '</section>' +
      '<section class="api-keys-card">' +
      '  <h2><i class="fa fa-bolt"></i> <%- t.webhook.title %></h2>' +
      '  <p class="api-keys-intro"><%- t.webhook.intro %></p>' +
      '  <form class="api-webhook-form js-webhook-form">' +
      '    <label><%- t.webhook.url %></label>' +
      '    <div class="api-webhook-row">' +
      '      <input type="url" class="form-control js-url" maxlength="255"' +
      '        placeholder="<%- t.webhook.urlPlaceholder %>" value="<%- webhook ? webhook.url : "" %>">' +
      '      <button type="submit" class="btn btn-primary"><%- t.webhook.save %></button>' +
      '    </div>' +
      '  </form>' +
      '  <% if (webhookMessage) { %><div class="api-keys-info"><%- webhookMessage %></div><% } %>' +
      '  <% if (webhookError) { %><div class="api-keys-error"><%- webhookError %></div><% } %>' +
      '  <% if (webhook) { %>' +
      '  <label><%- t.webhook.secret %></label>' +
      '  <div class="api-keys-secret">' +
      '    <code class="js-secret"><%- showSecret ? webhook.secret : mask(webhook.secret) %></code>' +
      '    <button type="button" class="api-doc-copy js-toggle-secret"><%- showSecret ? t.webhook.hide : t.webhook.show %></button>' +
      '    <button type="button" class="api-doc-copy js-copy-secret"><%- ui.copy %></button>' +
      '  </div>' +
      '  <div class="api-webhook-actions">' +
      '    <button type="button" class="btn btn-default btn-sm js-ping"><i class="fa fa-paper-plane"></i> <%- t.webhook.ping %></button>' +
      '    <button type="button" class="btn btn-default btn-sm js-rotate"><i class="fa fa-refresh"></i> <%- t.webhook.rotate %></button>' +
      '    <button type="button" class="btn btn-default btn-sm js-remove-webhook">' +
      '      <i class="fa fa-trash"></i> <%- t.webhook.remove %></button>' +
      '  </div>' +
      '  <div class="api-webhook-events"><span><%- t.webhook.events %></span>' +
      '    <% _.each(webhook.events || [], function (e) { %><code><%- e %></code><% }); %></div>' +
      '  <% } else { %>' +
      '  <div class="api-keys-empty"><%- t.webhook.none %></div>' +
      '  <% } %>' +
      '</section>'
    ),

    events: {
      'submit .js-create-form': 'onCreate',
      'click .js-revoke': 'onRevoke',
      'click .js-copy-key': 'onCopyKey',
      'submit .js-webhook-form': 'onSaveWebhook',
      'click .js-toggle-secret': 'onToggleSecret',
      'click .js-copy-secret': 'onCopySecret',
      'click .js-ping': 'onPing',
      'click .js-rotate': 'onRotate',
      'click .js-remove-webhook': 'onRemoveWebhook'
    },

    initialize: function (options) {
      this.content = options.content;
      this.language = options.language;
      this.keys = [];
      this.webhook = null;
      this.created = null;
      this.showSecret = false;
      this.load();
    },

    serializeData: function () {
      var language = this.language;
      return {
        t: this.content.ui,
        ui: this.content.ui,
        keys: this.keys,
        created: this.created,
        error: this.error,
        webhook: this.webhook,
        webhookMessage: this.webhookMessage,
        webhookError: this.webhookError,
        showSecret: this.showSecret,
        date: function (value) {
          if (!value) {
            return '';
          }
          try {
            return new Date(value).toLocaleString(language);
          } catch (e) {
            return new Date(value).toLocaleString();
          }
        },
        mask: function (secret) {
          return secret ? secret.substring(0, 10) + new Array(Math.max(0, secret.length - 10) + 1).join('•') : '';
        }
      };
    },

    load: function () {
      var that = this;
      $.when(App.request('apiKeys:list'), App.request('apiKeys:webhook:get')).done(function (keys, webhook) {
        that.keys = keys || [];
        that.webhook = webhook || null;
        that.renderIfAlive();
      }).fail(function (xhr) {
        that.error = errorMessage(xhr, that.content.ui.keys.error);
        that.renderIfAlive();
      });
    },

    renderIfAlive: function () {
      if (!this.isDestroyed) {
        this.render();
      }
    },

    onCreate: function (e) {
      e.preventDefault();
      var that = this,
        name = $.trim(this.$('.js-name').val());
      if (!name) {
        this.$('.js-name').focus();
        return;
      }
      this.$('.js-create').prop('disabled', true);
      App.request('apiKeys:create', name).done(function (key) {
        that.created = key;
        that.error = null;
        that.keys.unshift(_.omit(key, 'key'));
        that.renderIfAlive();
      }).fail(function (xhr) {
        that.error = errorMessage(xhr, that.content.ui.keys.error);
        that.renderIfAlive();
      });
    },

    onRevoke: function (e) {
      var that = this,
        secId = $(e.currentTarget).data('sec-id');
      if (!window.confirm(this.content.ui.keys.revokeConfirm)) {
        return;
      }
      App.request('apiKeys:revoke', secId).done(function (key) {
        that.keys = _.map(that.keys, function (k) { return k.secId === secId ? key : k; });
        if (that.created && that.created.secId === secId) {
          that.created = null;
        }
        that.renderIfAlive();
      }).fail(function (xhr) {
        that.error = errorMessage(xhr, that.content.ui.keys.error);
        that.renderIfAlive();
      });
    },

    onCopyKey: function (e) {
      Content.copy(this.created ? this.created.key : '', $(e.currentTarget), this.content.ui);
    },

    saveWebhook: function (url, rotate) {
      var that = this;
      return App.request('apiKeys:webhook:set', url, rotate).done(function (webhook) {
        that.webhook = webhook;
        that.webhookError = null;
        that.webhookMessage = that.content.ui.webhook.saved;
        that.renderIfAlive();
      }).fail(function (xhr) {
        that.webhookMessage = null;
        that.webhookError = errorMessage(xhr, that.content.ui.keys.error);
        that.renderIfAlive();
      });
    },

    onSaveWebhook: function (e) {
      e.preventDefault();
      var url = $.trim(this.$('.js-url').val());
      if (!url) {
        this.$('.js-url').focus();
        return;
      }
      this.saveWebhook(url, false);
    },

    onToggleSecret: function () {
      this.showSecret = !this.showSecret;
      this.render();
    },

    onCopySecret: function (e) {
      Content.copy(this.webhook ? this.webhook.secret : '', $(e.currentTarget), this.content.ui);
    },

    onPing: function () {
      var that = this;
      App.request('apiKeys:webhook:ping').done(function () {
        that.webhookError = null;
        that.webhookMessage = that.content.ui.webhook.pingSent;
        that.renderIfAlive();
      }).fail(function (xhr) {
        that.webhookMessage = null;
        that.webhookError = errorMessage(xhr, that.content.ui.keys.error);
        that.renderIfAlive();
      });
    },

    onRotate: function () {
      if (this.webhook && window.confirm(this.content.ui.webhook.rotateConfirm)) {
        this.showSecret = true;
        this.saveWebhook(this.webhook.url, true);
      }
    },

    onRemoveWebhook: function () {
      var that = this;
      if (!window.confirm(this.content.ui.webhook.removeConfirm)) {
        return;
      }
      App.request('apiKeys:webhook:delete').done(function () {
        that.webhook = null;
        that.webhookMessage = null;
        that.webhookError = null;
        that.renderIfAlive();
      }).fail(function (xhr) {
        that.webhookError = errorMessage(xhr, that.content.ui.keys.error);
        that.renderIfAlive();
      });
    }
  });
});

